import React, { useEffect, useState } from 'react'
import { EditPaper } from '@/features/test-paper/pages/EditPaper/EditPaper'
import { getTheme } from '@/utils/theme'
import { GrowpIcon } from 'packages/components/GrowpIcon'
import { paperApi } from 'packages/sdks-next/growp'
import { PaperInfoCard } from '@/uikit/QuotePaper/PaperInfoCard'
import styled from 'styled-components'
import { Modal, Toast } from '@seiue/ui'

/**
 * 课程习题|测验试卷设置
 * @param param - 参数
 * @param param.value - paperId
 * @param param.onChange - paperId变化回调
 * @param param.isRand - 是否是抽题模式
 * @param param.setBlockCount - 设置题目数量
 * @returns React.ReactNode
 */
export const ExerciseSetting: React.FC<{
  value?: number
  onChange?: (v?: number) => void
  isRand?: boolean
  setBlockCount?: (v: number) => void
  isQuiz?: boolean
  limitLevel?: number
}> = ({ value, onChange, isRand, setBlockCount, isQuiz, limitLevel }) => {
  const theme = getTheme()
  const [visible, setVisible] = useState<boolean>(false)
  const [paperId, setPaperId] = useState<number | undefined>(undefined)
  useEffect(() => {
    setPaperId(value)
  }, [value])
  const { api: createPaper } = paperApi.useCreatePaper({
    reload: [paperApi.queryPapers],
  })

  const { data: paperInfo } = paperApi.useLoadPaper(
    {
      id: paperId || 0,
      query: {
        expand: ['questionCount'],
      },
    },
    {
      disable: !paperId,
    }
  )

  const { questionCount, scoreSum, showScore } = paperInfo || {}

  useEffect(() => {
    setBlockCount && setBlockCount(questionCount || 0)
  }, [questionCount])
  return (
    <>
      {visible && paperId ? (
        <EditPaper
          isRand={isRand}
          title={isQuiz ? '创建试卷' : '创建习题'}
          showQuote={true}
          paperId={paperId}
          onClose={() => {
            if (paperInfo?.questionCount === 0) {
              Modal.confirm({
                title: '确定关闭该页面吗？',
                content: '正在关闭该界面，已创建的内容将被清空，确认关闭吗？',
                onOk: () => {
                  setPaperId(undefined)
                  onChange && onChange(undefined)
                  setVisible(false)
                },
                okButtonProps: {
                  style: {
                    backgroundColor: theme.brand._1,
                    border: 'none',
                  },
                },
                cancelButtonProps: {
                  style: {
                    color: theme.text._2,
                  },
                },
              })
              return
            }
            setVisible(false)
          }}
          onSuccess={() => {
            if (paperInfo?.questionCount === 0) {
              Toast.warning('试卷中题目不能为空')
              return
            }
            setVisible(false)
          }}
          controlVisible={true}
          visible={visible}
          limitLevel={limitLevel}
        />
      ) : null}
      {paperId && paperInfo?.questionCount ? (
        <PaperInfoCard
          showScore={!!showScore}
          fullScore={scoreSum || 0}
          questionCount={questionCount || 0}
          showEditPaperModal={() => setVisible(true)}
        />
      ) : (
        <CreatePaperWrapper
          $isQuiz={!!isQuiz}
          onClick={async () => {
            const { data } = await createPaper({
              isShow: 0,
            })
            if (data.id) {
              setPaperId(data.id)
              onChange && onChange(data.id)
              setVisible(true)
            }
          }}
        >
          <GrowpIcon
            name={'Plus'}
            text={isQuiz ? '创建试卷' : '创建习题'}
            size={14}
            color={theme.brand._1}
          />
        </CreatePaperWrapper>
      )}
    </>
  )
}

const CreatePaperWrapper = styled.div<{ $isQuiz: boolean }>`
  width: 90px;
  height: 28px;
  display: flex;
  justify-content: ${(props) => (props.$isQuiz ? 'center' : 'flex-start')};
  border-radius: 8px;
  cursor: pointer;
  border: ${(props) =>
    props.$isQuiz ? `1px solid ${props.theme.brand._1}` : 'none'};
`
